<div [matTooltip]="'Draw'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-draw'"
    (click)="penMenuTrigger.openMenu(); onStartDrawing()"
  >
    <fa-icon [icon]="['fal', 'pen']"></fa-icon>
    <div class="menu-trigger" #penMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="penMenu"></div>
  </button>
</div>

<mat-menu
  class="toolbar-panel-pen-menu"
  xPosition="before"
  #penMenu="matMenu"
  [overlapTrigger]="false"
  [backdropClass]="toolbarBackdropClass"
>
  <button mat-menu-item (click)="onStartDrawing(drawingWidths.thin)">
    <fa-layers [fixedWidth]="true">
      <fa-icon [icon]="['fal', 'circle']" class="text-[16px]"></fa-icon>
      <fa-icon [icon]="['fas', 'circle']" class="text-[6px]" transform="shrink-6"></fa-icon>
    </fa-layers>
  </button>
  <button mat-menu-item (click)="onStartDrawing(drawingWidths.thick)">
    <fa-layers [fixedWidth]="true">
      <fa-icon [icon]="['fal', 'circle']" class="text-[16px]"></fa-icon>
      <fa-icon [icon]="['fas', 'circle']" class="text-[16px]" transform="shrink-6"></fa-icon>
    </fa-layers>
  </button>
</mat-menu>
